<template>
  <div class="tencent-map">
    <el-input v-model="pos" id="place" @focus="handleFocus" @blur="handleBlur" clearable placeholder="搜索地点"></el-input>
    <div class="items" v-if="datas.length">
      <div v-for="(value, index) in datas" :key="index" class="app-control" @click="handleItem(value)">
        <p :title="value.name">{{value.name}}</p>
        <div class="right-region">
          <p :title="value.address">{{value.address}}</p>
        </div>
      </div>
    </div>
    <div id="container"></div>
  </div>
</template>

<script>
  export default {
    name: 'TencentMap',
    props: {
      value: {
        type: Object,
        default() {
          return null;
        }
      },
      city: {
        type: String,
        default: null
      },
      params: {
        type: Object,
        default() {
          return {};
        }
      },
    },
    watch: {
      value: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            if (!this.map) {
              this.initMap();
              this.initMapSearchService();
              // this.initMapCityService();
              this.initMapGeocoderService();
              this.initMapEvent();
            }
            if (newValue) {
              let latLng = this.createPos(newValue.lat, newValue.lng);
              if (!this.isSetCenter) {
                this.setMapCenter(latLng);
              }
              this.isSetCenter = true;
              this.createMarker(latLng);
            }
          });
        },
        immediate: true
      },
      city: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            if (newValue) {
              // this.cityService.searchCityByName(newValue);
              this.searchService.setLocation(newValue);
            }
          });
        },
        immediate: true
      },
      pos(newValue, oldValue) {
        if (this.isSearch) {
          this.debounce(() => {
            this.searchService.search(newValue);
          })();
        }
      }
    },
    data() {
      return {
        isSearch: false, // 是否搜索
        pos: '', // 搜索关键词
        map: null, // 地图
        searchService: null, // 搜索服务
        // cityService: null, // 城市服务
        geocoderService: null, // 地址解析服务
        marker: null, // 地图标记
        datas: [], // 关键词搜索结果
        isSetCenter: false // 是否设置地图中心
      }
    },
    methods: {
      handleBlur() {
        this.isSearch = false;
      },
      handleFocus() {
        this.isSearch = true;
      },
      updatePos(name) {
        this.pos = name;
      },
      // renderMap(data) {
      //   this.updatePos(data.name);
      //   this.createMarker(data.latLng);
      // },
      handleItem(data) {
        this.updatePos(data.name);
        this.createMarker(data.latLng);
        this.setMapCenter(data.latLng);
        this.datas = [];
        this.updateValue(data);
      },
      updateValue(data) {
        this.$emit('input', {
          lat: data.latLng.lat,
          lng: data.latLng.lng
        });
      },
      initMapSearchService() {
        this.searchService = new qq.maps.SearchService();
        this.searchService.setComplete(result => {
          this.datas = result.detail.pois || [];
        });
      },
      // initMapCityService() {
      //   this.cityService = new qq.maps.CityService();
      //   this.cityService.setComplete(result => {
      //     this.setMapCenter(result.detail.latLng);
      //   });
      // },
      initMapGeocoderService() {
        this.geocoderService = new qq.maps.Geocoder();
        this.geocoderService.setComplete(result => {
          let name = result.detail.address;
          let latLng = result.detail.location;
          this.updatePos(name);
          this.updateValue({
            name,
            latLng
          });
        });
      },
      initMapEvent() {
        qq.maps.event.addListener(this.map, 'click', event => {
          this.createMarker(event.latLng);
          this.geocoderService.getAddress(event.latLng);
        });
      },
      initMap() {
        this.map = new qq.maps.Map(
          document.getElementById('container'),
          {
            zoom: 17,
            ...this.params
          }
        );
      },
      setMapCenter(latLng) {
        if (this.map) {
          this.map.setCenter(latLng);
        }
      },
      createMarker(latLng) {
        if (this.marker) {
          this.marker.setMap(null);
        }
        this.marker = new qq.maps.Marker({
          position: latLng,
          map: this.map
        });
      },
      createPos(lat, lng) {
        return new qq.maps.LatLng(lat, lng);
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .tencent-map {
    .el-input {
      margin-bottom: 10px;
    }
    .items {
      border: 1px dashed @color-border-1;
      font-size: 12px;
      margin-bottom: 10px;
      max-height: 300px;
      overflow: auto;
      .app-control {
        padding: 0 15px;
        margin: 0;
        cursor: pointer;
        &:hover {
          background-color: @color-primary;
          color: @color-white;
          .right-region {
            p {
              color: @color-white;
            }
          }
        }
        p {
          .text-overflow;
        }
        .right-region {
          p {
            color: @color-text-3;
          }
        }
      }
    }
    #container {
      width: 100%;
      height: 300px;
    }
  }
</style>